import styled from "styled-components";
import { Button } from "../../atoms/button/button";
import { Container } from "../../../styles/common/container";

export const PaidUserMobileUserNotice = styled.div`
  padding: 16px 20px;
  background:
    url("/assets/kelas-live/user-notice-stars.svg") right -30px bottom -30px
      no-repeat,
    ${({ theme }) => theme.colors.green[600]};
`;

export const PaidUserMobileUserNoticeMessageHeading1 = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.md};
  line-height: 1;
  margin: 0 0 4px 0;
  color: ${({ theme }) => theme.colors.white};
`;
export const PaidUserMobileUserNoticeMessageHeading2 = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: 1;
  margin: 0 0 4px 0;
  color: ${({ theme }) => theme.colors.white};
`;

export const PaidUserMobileUserNoticeMessage = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: 1;
  color: ${({ theme }) => theme.colors.white};
`;

export const PaidUserMobileSection = styled.section`
  background-color: ${({ theme }) => theme.colors.brand[500]};
`;
export const PaidUserMobileHeading = styled.h1`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  line-height: 1.1;
  text-align: center;
  margin: 0 0 4px 0;
  color: ${({ theme }) => theme.colors.white};
`;

export const PaiUserMobileFeatureBlock = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.brand[700]};
  padding: 16px;
  border-radius: 16px;
  gap: 16px;
`;

export const PaidUserMobileFeatureBlockImageWrapper = styled.figure`
  margin: 0;
  border-radius: 8px;
  overflow: hidden;
  width: 80px;
  height: 80px;
  position: relative;
`;

export const PaidUserMobileFeatureBlockImage = styled.img`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
`;

export const PaidUserMobileFeatureBlockDetails = styled.div``;

export const PaidUserMobileFeatureBlockHeading = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: 1;
  color: ${({ theme }) => theme.colors.white};
  margin: 0 0 8px 0;
`;

export const PaidUserMobileFeatureBlockLink = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.md};
  line-height: 1;
  color: ${({ theme }) => theme.colors.white};
  margin: 0;
`;

export const PaidUserMobileFeatureBlockCTA = styled.a`
  --webkit-appearance: none;
  background-color: ${({ theme }) => theme.colors.brand[50]};
  color: ${({ theme }) => theme.colors.brand["500"]} !important;
  font-weight: bold;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 10px 16px;
  border-radius: 4px;
  box-shadow: none;
  border: none;
  cursor: pointer;
  max-width: 160px;
  white-space: nowrap;
  text-decoration: none;
`;

export const PaidUserMobileDivider = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: 1;
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  gap: 10px;

  &:before,
  &:after {
    content: "";
    height: 2px;
    width: 100%;
    background-color: ${({ theme }) => theme.colors.white};
  }
`;

export const PaidUserWeeklySchedule = styled.div`
  text-align: center;
  margin: 20px;
  padding-bottom: 20px;
`;
export const PaidUserWeeklyScheduleButton = styled(Button)`
  align-items: center;
  gap: 10px;
  display: inline-flex;
`;

export const KelasLiveSectionContainer = styled.div`
  position: relative;
  margin-bottom: 2%;
`;

export const KelasLiveUpcomingContainer = styled(Container)`
  margin-top: -40%;
  position: relative;
`;

export const KelasLiveOngoingContainer = styled.div`
  margin-top: -35%;
  position: relative;
`;

export const PaidUserStudentHeading = styled.h2`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  color: ${({ theme }) => theme.colors.white};
  line-height: 1;
  margin-bottom: 40px;
`;

export const PaidUserStudentClassHeading = styled.h2`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["xl"]};
  color: ${({ theme }) => theme.colors.white};
  line-height: 1;
  margin-bottom: 30px;
`;

export const SectionContainerFirstSection = styled.div`
  min-width: max-content;
`;

export const SectionContainerSecondSection = styled.div``;
